/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';

    interface ILangSwitcherOption {
        id: number;
        title: string;
        value: string;
    }

    declare type LanguageSwitcherDirectiveFactoryCb = ($rootScope: IFlexRootScope,
                                                       $document: ng.IDocumentService,
                                                       $timeout: ng.ITimeoutService) => LanguageSwitcherDirective;

    interface ILanguageSwitcherDirectiveScope extends ng.IScope {
        langSwitcherOptions: ILangSwitcherOption[];
        langSwitcherConfig: Selectize.IOptions<number, ILangSwitcherOption>;
    }

    export class LanguageSwitcherDirective implements ng.IDirective {
        public static $name: string = 'languageSwitcher';

        public link: ($scope: ng.IScope, $element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'E';
        public template: string = '<select id="lang_switcher" name="lang_switcher"></select>';
        public replace: boolean = true;

        /**
         * Factory for the directive
         */
        public static Factory(): LanguageSwitcherDirectiveFactoryCb {
            let directive: LanguageSwitcherDirectiveFactoryCb = ($rootScope: IFlexRootScope,
                                                               $document: ng.IDocumentService,
                                                               $timeout: ng.ITimeoutService) => {
                return new LanguageSwitcherDirective($rootScope, $document, $timeout);
            };
            directive.$inject = ['$rootScope', '$document', '$timeout'];
            return directive;
        }

        /**
         * Constructor
         */
        constructor($rootScope: IFlexRootScope,
                    $document: ng.IDocumentService,
                    $timeout: ng.ITimeoutService) {

            LanguageSwitcherDirective.prototype.link = ($scope: ILanguageSwitcherDirectiveScope,
                                                        $element: JQuery,
                                                        attrs: ng.IAttributes) => {

                $rootScope.langSwitcherModel = 'gb';

                $scope.langSwitcherOptions = [
                    {id: 1, title: 'English', value: 'gb'},
                    /*{id: 2, title: 'French', value: 'fr'},
                    {id: 3, title: 'Chinese', value: 'cn'},
                    {id: 4, title: 'Dutch', value: 'nl'},
                    {id: 5, title: 'Italian', value: 'it'},
                    {id: 6, title: 'Spanish', value: 'es'},
                    {id: 7, title: 'German', value: 'de'},
                    {id: 8, title: 'Polish', value: 'pl'},*/
                ];

                $scope.langSwitcherConfig = {
                    maxItems: 1,
                    render: {
                        option: (lang: ILangSwitcherOption, escape: (input: string) => string) => {
                            return  '<div class="option">' +
                                '<i class="item-icon flag-' + escape(lang.value).toUpperCase() + '"></i>' +
                                '<span>' + escape(lang.title) + '</span>' +
                                '</div>';
                        },
                        item: (lang: ILangSwitcherOption, escape: (input: string) => string) => {
                            return '<div class="item"><i class="item-icon flag-' + escape(lang.value).toUpperCase() + '"></i></div>';
                        },
                    },
                    valueField: 'value',
                    labelField: 'title',
                    searchField: 'title',
                    options: $scope.langSwitcherOptions,
                    create: false,
                };

                $timeout(() => {
                    let $select: JQuery = $element.selectize($scope.langSwitcherConfig);
                    $select[0].selectize.setValue($rootScope.langSwitcherModel);
                });
            };
        }
    }
}